import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox='0 0 15 12'
        {...props}
    >
        <g transform="translate(0, -2.000000)">
            <path
                d="M8.66666667,2 C5.35333333,2 2.66666667,4.68666667 2.66666667,8 L0.666666667,8 L3.26,10.5933333 L3.30666667,10.6866667 L6,8 L4,8 C4,5.42 6.08666667,3.33333333 8.66666667,3.33333333 C11.2466667,3.33333333 13.3333333,5.42 13.3333333,8 C13.3333333,10.58 11.2466667,12.6666667 8.66666667,12.6666667 C7.38,12.6666667 6.21333333,12.14 5.37333333,11.2933333 L4.42666667,12.24 C5.51333333,13.3266667 7.00666667,14 8.66666667,14 C11.98,14 14.6666667,11.3133333 14.6666667,8 C14.6666667,4.68666667 11.98,2 8.66666667,2 Z M8,5.33333333 L8,8.66666667 L10.8533333,10.36 L11.3333333,9.55333333 L9,8.16666667 L9,5.33333333 L8,5.33333333 Z"
                id="Shape"></path>
        </g>
    </svg>
)
